<template>
<div class="freeDown">
<div v-html="content"></div>
</div>
</template>

<script>
import api from '@/api/jiJing.js'
export default{
    data(){
        return{
            content:''
        }
    },
    mounted(){
        this.getData()
    },
    methods: {
        getData(){
            api.collectDown().then(res => {
                if(res.data.code == 0){
                    this.content = res.data.data.content
                }
            })
        }
    },
}
</script>

<style scope>
.freeDown{
    box-sizing: border-box;
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/saomang/down.vue